import { Injectable, signal } from '@angular/core';

@Injectable()
export class AppSignalDataService {

  public isCollapsedMenuAside$ = signal(false);
  public showScore$ = signal<number | undefined>(undefined);

  constructor() { }

  public updateCollapsedMenuAside(value: boolean) {
    this.isCollapsedMenuAside$.set(value);
  }

  public updateShowScore(value: boolean) {
    this.isCollapsedMenuAside$.set(value);
  }
}
